(ns common.core
  (:require [assemble.assets-page.db]
            [assemble.resource.asset]
            [assemble.resource.asset-tree]
            [assemble.resource.template]
            [common.advertiser-selection-ocp.view]
            [common.agency-selection-ocp.view]
            [common.app :as app]
            [common.archive-modal.db]
            [common.archive-modal.view]
            [common.datascript.init]
            [common.db.asset-upload.core]
            [common.db.asset-upload.resumable]
            [common.db.coeffects.cookie]
            [common.db.coeffects.env]
            [common.db.coeffects.localstorage]
            [common.db.coeffects.namespace-values]
            [common.db.coeffects.query-params]
            [common.db.coeffects.sub]
            [common.db.config]
            [common.db.context]
            [common.db.effects.binary]
            [common.db.effects.clipboard]
            [common.db.effects.cookie]
            [common.db.effects.csv]
            [common.db.effects.debounce]
            [common.db.effects.dispatch-interval]
            [common.db.effects.http]
            [common.db.effects.json]
            [common.db.effects.localstorage]
            [common.db.effects.posh]
            [common.db.effects.query]
            [common.db.effects.router]
            [common.db.effects.sentry]
            [common.db.router]
            [common.db.sentry]
            [common.dev-tools :as dev-tools]
            [common.dispatcher :as dispatcher]
            [common.flags]
            [common.mui :as mui]
            [common.resource.adserver-account]
            [common.resource.adserver-account-configuration]
            [common.resource.adset]
            [common.resource.advertiser]
            [common.resource.auth]
            [common.resource.roles]
            [common.resource.user]
            [common.response-handler.core]
            [common.router :as router]
            [common.sentry :refer [init-sentry]]
            [common.spec]
            [day8.re-frame.async-flow-fx]
            [day8.re-frame.forward-events-fx]
            [lemonpi.domain.interface.permission :as permission]
            [manage.adset-decision-tree-page.core]
            [manage.adset-integration-meta-settings.view]
            [manage.adset-preview-panel.db.content-function-version]
            [manage.adset-preview-panel.db.core]
            [manage.adset-preview-panel.db.notifications]
            [manage.adset-preview-panel.db.products]
            [manage.adset-preview-panel.db.templates]
            [manage.adset-preview-panel.db.variants]
            [manage.adset-template-page.db.db]
            [manage.adset-template-page.view.add-modal]
            [manage.adset.modal.view]
            [manage.adset.ocp.view]
            [manage.campaign.modal]
            [manage.column-classification-table.db]
            [manage.content-configuration-page.db]
            [manage.content-configuration-page.view.datoms :refer [datoms-table]]
            [manage.content-configuration-page.view.import :refer [content-function-export-import]]
            [manage.content-mapping-table.db]
            [manage.content-variant-ocp.db.column-classification]
            [manage.content-variant-ocp.db.content-mapping]
            [manage.content-variant-ocp.db.core]
            [manage.content-variant-ocp.db.lookup]
            [manage.content-variant-ocp.db.sheet-import]
            [manage.content-variant-ocp.view]
            [manage.content-variant-page.db]
            [manage.content-variant-page.modal.db]
            [manage.content-variant-page.modal.view]
            [manage.content-variant-page.table.db]
            [manage.duplicate-adset-ocp.db]
            [manage.duplicate-adset-ocp.view]
            [manage.export-display-modal.db]
            [manage.export-display-modal.view]
            [manage.export-ocp.db]
            [manage.export-ocp.view]
            [manage.export-tags-ocp.db]
            [manage.external-template-ocp.db]
            [manage.external-template-ocp.view]
            [manage.external-templates-page.db]
            [manage.external-templates-page.view]
            [manage.feed-importer-ocp.view]
            [manage.feed-lookup-table.db]
            [manage.feed-mapping-table.db]
            [manage.feed-table.db]
            [manage.privacy-modal.db :as privacy-modal]
            [manage.privacy-modal.view]
            [manage.product-modal.view]
            [manage.product-ocp.view]
            [manage.product-selector-ocp.view]
            [manage.resource.adform-campaigns]
            [manage.resource.adset-activation]
            [manage.resource.adset-preview]
            [manage.resource.campaign-insights]
            [manage.resource.content-function]
            [manage.resource.content-optimizing]
            [manage.resource.content-variants]
            [manage.resource.export]
            [manage.resource.feed-imports]
            [manage.resource.product]
            [manage.resource.product-selector]
            [manage.resource.schema]
            [manage.resource.script]
            [manage.resource.template]
            [manage.script-ocp.db]
            [manage.script-ocp.view]
            [manage.template-table.db]
            [manage.variants-preview-panel.db.core]
            [measure.reporting-ocp.db.core]
            [measure.reporting-ocp.view.core]
            [measure.resource.report]
            [measure.resource.report-schedule]
            [portal.adserver-configuration-ocp.db]
            [portal.adserver-configuration-ocp.view]
            [portal.adserver-ocp.db]
            [portal.adserver-ocp.view]
            [portal.advertiser-configuration-page.db.core]
            [portal.advertiser-configuration-page.db.whitelist]
            [portal.advertiser-modal.view]
            [portal.agency-configuration-page.db]
            [portal.backup-image-ocp.view]
            [portal.delivery-table.db]
            [portal.resource.delivery]
            [portal.role-ocp.db]
            [portal.role-ocp.view]
            [portal.role-table.db]
            [portal.third-party-credentials.ocp]
            [portal.user-account-page.db.change-password]
            [portal.user-account-page.db.personal-information]
            [portal.user-ocp.db]
            [portal.user-ocp.view]
            [re-frame.core :as rf]
            [reagent.core]
            [superadmin.agency-ocp.db]
            [superadmin.agency-ocp.view]
            [superadmin.page.db]
            [uix.core :refer [$]]
            [viesti.frontend.tools :as vft]))

(defn ^:dev/after-load mount-app []
  (app/start-app!))

;; Call this in the browser's console using `common.core.start_dev_tool(true)`.
(defn ^:export start-dev-tool [force-enable]
  (dev-tools/start {:force-enable force-enable
                    :panels (into (vft/create-panels
                                   {:permissions permission/permissions
                                    :cqrs true})
                                  [{:key :fixtures
                                    :label "Fixtures"
                                    :view [:<> ($ dev-tools/assemble-fixtures-view)]}
                                   {:key :manage-datoms
                                    :label "Datoms"
                                    :view [:<> ($ mui/theme-provider ($ datoms-table))]}
                                   {:key :manage-import-payload
                                    :label "Content Function"
                                    :view [:<> ($ mui/theme-provider ($ content-function-export-import))]}])})
  ;; Instead of printing the Clojure keyword :started in the JS console, return this for the end user.
  "started")

(defn init-app []
  (rf/clear-subscription-cache!)
  (rf/dispatch-sync [:config/init])
  (start-dev-tool false)
  (dispatcher/start)
  (mui/set-license)
  (privacy-modal/start)
  (router/init-routes!)
  (init-sentry))

(defn init []
  (init-app)
  (mount-app))
